import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  // {
  //     path: 'dashboard',
  //     loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  // },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'incidents',
    loadChildren: () => import('./components/incidents/incidents.module').then((m) => m.IncidentsModule),
  },
  {
    path: 'audits',
    loadChildren: () => import('./components/audits/audits.module').then((m) => m.AuditsModule),
  },
  {
    path: 'account',
    loadChildren: () => import('./components/myaccount/myaccount.module').then((m) => m.MyaccountModule),
  },
  {
    path: 'create-new-audit',
    loadChildren: () => import('./components/new-audits/new-audits.module').then((m) => m.NewAuditsModule),
  },
  {
    path: 'create-new-incident',
    loadChildren: () => import('./components/new-incidents/new-incidents.module').then((m) => m.NewIncidentsModule),
  },
  {
    path: 'authentication',
    loadChildren: () => import('./authentication/authentication.module').then((m) => m.AuthenticationModule),
  },
  {
    path: 'simlogin',
    loadChildren: () => import('./simlogin/simlogin.module').then((c) => c.SimLoginModule),
  },
  {
    path: "error_display",
    loadChildren: () => import("./error/error.module").then((c) => c.ErrorModule),
  },
  {
    path: 'createautologin',
    loadChildren: () => import('./create-new-autologin-audit/autologin.module').then((c) => c.AutoLoginModule),
  },
  {
    path: 'notification',
    loadChildren: () => import('./components/notification/notification.module').then((c) => c.NotificationModule),
  },
  {
    path: 'near-miss',
    loadChildren: () => import('./near-miss/near-miss.module').then((m) => m.NearMissModule),
  },
  {
    path: '',
    redirectTo: 'authentication/signin',
    pathMatch: 'full',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
